module.exports = __webpack_public_path__ + "static/media/google-icon1.5910ab9b.svg";